import { render, staticRenderFns } from "./Para.vue?vue&type=template&id=a7475d10&scoped=true&"
import script from "./Para.vue?vue&type=script&lang=js&"
export * from "./Para.vue?vue&type=script&lang=js&"
import style0 from "./Para.vue?vue&type=style&index=0&id=a7475d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7475d10",
  null
  
)

export default component.exports